import { PatientFilterOptions } from "../types";

const all = ['patients'] as const;

export const patientLogsKeys = {
    all,
    list: (filters: PatientFilterOptions) => [...all, filters] as const,
    detail: (id: string) => [...all, id] as const,
    programSummary: () => [...all, 'program-summary'] as const,
    timeline: (patientId: string) => [...all, 'timeline', patientId] as const,
    medication: (patientId: string) => [...all, 'medication', patientId] as const,
    medicalPlan: (patientId: string) => [...all, 'medical-plan', patientId] as const,
    paymentHistory: (patientId: string) => [...all, 'payment-history', patientId] as const,
    notes: (patientId: string) => [...all, 'notes', patientId] as const,
    questionnaire: (patientId: string) => [...all, 'questionnaire', patientId] as const,
    sessions: (patientId: string) => [...all, 'sessions', patientId] as const,
    medicalHistory: (patientId: string) => [...all, 'medical-history', patientId] as const,
    refills: (patientId: string) => [...all, 'refills', patientId] as const,
    icd10Search: (searchTerm: string) => ['icd10', 'search', searchTerm] as const,
    verification: (patientId: string) => [...all, 'verification', patientId] as const,
};